import React, { useEffect, useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import "./PieChartComponent.css";
import { getAllForms } from "../../services/formService";

const PieChartComponent = () => {
  const [data, setData] = useState([]);
  const [forms, setForms] = useState([]);

  useEffect(() => {
    fetchForms();
  }, []);

  const fetchForms = async () => {
    try {
      const response = await getAllForms();
      const formsData = response?.forms || [];
      setForms(formsData);

      const tourTypeCounts = formsData.reduce((acc, form) => {
        if (form.cart && Array.isArray(form.cart)) {
          form.cart.forEach((item) => {
            const tourType = item.typeOfTour || "Unknown";
            acc[tourType] = (acc[tourType] || 0) + 1;
          });
        }
        return acc;
      }, {});

      const chartData = Object.keys(tourTypeCounts).map((key) => ({
        name: key,
        value: tourTypeCounts[key],
      }));

      setData(chartData);
    } catch (error) {
      console.error("Error fetching forms:", error);
      setData([]);
    }
  };

  const COLORS = {
    Joiners: "#f49595",
    "Boat Rental": "#fec89a",
    Private: "#a9e4de",
    "7D6N": "#ded6ce",
    "6D5N": "#dfe1be",
    "5D4N": "#fcd5ce",
    "4D3N": "#f1deee",
    "3D2N": "#f3d17c",
    Expedition: "#c4b7bb",
    Unknown: "#808080",
  };

  return (
    <div className="pieChartComponent">
      <h2>Tour Type Distribution</h2>
      <div className="chart-container">
        {data.length > 0 ? (
          <ResponsiveContainer
            width="90%"
            height={400}
            minWidth={300}
            maxWidth={800}
          >
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                outerRadius={window.innerWidth > 1024 ? "65%" : "50%"}
                fill="#8884d8"
                dataKey="value"
                nameKey="name"
                label={({ name, percent }) =>
                  `${name} ${(percent * 100).toFixed(0)}%`
                }
              >
                {data.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[entry.name] || "#000000"}
                  />
                ))}
              </Pie>
              <Tooltip contentStyle={{ fontSize: "14px" }} />
              <Legend
                verticalAlign="bottom"
                align="center"
                height={50}
                wrapperStyle={{ fontSize: "14px" }}
              />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <p>Loading data...</p>
        )}
      </div>
    </div>
  );
};

export default PieChartComponent;
